<template>
  <div>
    <mobile-dialog title="活动规则" :visible.sync="dialogVisible" @close="close" @confirm="close">
      <template #content>
        <div class="rule">{{ rule }}</div>
      </template>
    </mobile-dialog>
  </div>
</template>

<script>
import MobileDialog from '../dialog/Index.vue'

export default {
  name: 'MobileRuleDialog',
  components: {
    MobileDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rule: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.rule {
  margin-bottom: 4vw;
  height: 60vw;
  font-size: 4vw;
  white-space: pre-wrap;
}
</style>